export const kgToPound = (n) => n * 2.205;
export const poundToKg = (n) => n / 2.205;
export const feetToCM = (foot, inches) => foot * 30.48 + inches * 2.54;

export const cmToFeet = (n) => {
  const totalInches = n / 2.54;
  const feet = parseInt(totalInches / 12);
  const inches = totalInches - 12 * feet;
  return [parseInt(feet), inches.toFixed(2)];
};

const normalizeMetrics = ({ height, heightMetric, weight, weightMetric }) => {
  const h =
    heightMetric === "cm" ? height : feetToCM(height.foot, height.inches);
  const w = weightMetric === "kg" ? weight : poundToKg(weight);

  return { height: parseInt(h), weight: parseInt(w) };
};

export const alanBaptistCalculator = ({
  gender,
  weight,
  activity,
  weightMetric = "kg",
}) => {
  const w = weightMetric === "kg" ? weight : poundToKg(weight);
  let bmr, tdee;
  if (gender === "Male") {
    bmr = 24 * w;
  } else {
    bmr = 22 * w;
  }
  tdee = bmr * activity;
  return {
    bmr: bmr.toFixed(2),
    tdee: tdee.toFixed(2),
  };
};

// For men: BMR = 66.5 + (13.75 * weight in kg) + (5.003 * height in cm) - (6.75 * age)
// For women: BMR = 655.1 + (9.563 * weight in kg) + (1.850 * height in cm) - (4.676 * age)
export const harrisBenedictCalculator = ({
  gender,
  weight,
  height,
  activity,
  age,
  heightMetric = "cm",
  weightMetric = "kg",
}) => {
  const converted = normalizeMetrics({
    height,
    heightMetric,
    weight,
    weightMetric,
  });
  let bmr = 0;
  console.log(height, weight, heightMetric, weightMetric);
  if (gender === "Male") {
    bmr = 88.4 + 13.4 * converted.weight + 4.8 * converted.height - 5.68 * age;
  } else {
    bmr = 447.6 + 9.25 * converted.weight + 3.1 * converted.height - 4.33 * age;
  }
  return {
    bmr: bmr.toFixed(2),
    tdee: (bmr * activity).toFixed(2),
  };
};

// Formula
export const miffinCalculator = ({
  gender,
  weight,
  activity,
  height,
  age,
  heightMetric,
  weightMetric,
}) => {
  let bmr = 0;
  const converted = normalizeMetrics({
    height,
    heightMetric,
    weight,
    weightMetric,
  });
  if (gender === "Male") {
    bmr = 9.99 * converted.weight + 6.25 * converted.height - 4.92 * age + 5;
  } else {
    bmr = 9.99 * converted.weight + 6.25 * converted.height - 4.92 * age - 161;
  }

  return {
    bmr: bmr.toFixed(2),
    tdee: (bmr * activity).toFixed(2),
  };
};

export const katchMcardle = ({
  weight,
  bodyFat,
  activity,
  weightMetric,
  height,
  heightMetric,
}) => {
  const converted = normalizeMetrics({
    height,
    heightMetric,
    weight,
    weightMetric,
  });
  const bmr = 370 + 21.6 * (1 - bodyFat / 10000) * converted.weight;
  return {
    bmr: bmr.toFixed(2),
    tdee: (bmr * activity).toFixed(2),
  };
};

export const calculateBmrAndTdee = ({ formula, ...values }) => {
  switch (formula) {
    case "harris-benedict":
      return harrisBenedictCalculator({ ...values });
    case "mifflin":
      return miffinCalculator({ ...values });
    case "alan-baptist":
      return alanBaptistCalculator({ ...values });
    case "katch-mcardle":
      return katchMcardle({ ...values });
    default:
      return alanBaptistCalculator({ ...values });
  }
};
